import React from "react";
import "./hero.css";
import { Container } from "react-bootstrap";
import { Button } from "@mui/material";
import ArrowOutwardIcon from "@mui/icons-material/ArrowOutward";
import { motion } from "framer-motion";

const Hero = () => {
  const heroText = {
    hidden: {
      opacity: 0,
      y: 100,
    },

    animate: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 1,
        ease: "easeOut",
        staggerChildren: 0.35,
      },
    },

    exit: {
      opacity: 0,
      y: 100,
      transition: {
        duration: 1,
        ease: "easeOut",
      },
    },
  };

  return (
    <section className="hero">
      {/* hero section */}
      <Container>
        <motion.span
          initial="hidden"
          animate="animate"
          exit="exit"
          variants={heroText}
        >
          Bringing your websites to life 🌱
        </motion.span>
        <motion.div
          initial="hidden"
          animate="animate"
          exit="exit"
          variants={heroText}
        >
          <h1>HELLO,</h1>
        </motion.div>
        <motion.h2
          initial="hidden"
          animate="animate"
          exit="exit"
          variants={heroText}
        >
          I'm Rehan Ankalgi.
        </motion.h2>
        <motion.p
          initial="hidden"
          animate="animate"
          exit="exit"
          variants={heroText}
        >
          A software developer with profound knowledge in web development,
          specialised in frontend development and UX
        </motion.p>
        <motion.div
          initial="hidden"
          animate="animate"
          exit="exit"
          variants={heroText}
        >
          <a
            href="https://api.whatsapp.com/send/?phone=%2B919741120672&text&type=phone_number&app_absent=0"
            target="_blank"
            rel="noreferrer"
          >
            <Button
              variant="outlined"
              color="green"
              // size="lg"
              endIcon={<ArrowOutwardIcon />}
            >
              Get in touch
            </Button>
          </a>
        </motion.div>
      </Container>
    </section>
  );
};

export default Hero;
